import { IHostDeposit, IHostDepositTopUp } from '../interfaces/heavyDutyMachinery/IHostDeposit';
import { apiService } from './ApiService';
import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { HTTP_METHODS } from '../constants/httpMethods';

const heavyDutyMachineryBaseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL || '';

/** The caller's own deposit position plus its ledger. Answers for a host who has never paid anything in -- all zeros, which is what the empty state renders from. */
export const getMyHostDeposit = async (): Promise<IHostDeposit> => {
  const response = await apiService<IHostDeposit>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_HOST_DEPOSIT,
    method: HTTP_METHODS.GET,
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to load the deposit');
};

/**
 * Starts a top-up and hands back a clientSecret to confirm with Stripe.js.
 *
 * The balance does NOT move on this call -- it moves when Stripe confirms the
 * payment, through the webhook. So a caller must reload the deposit after
 * `onPaid`, not assume the new figure, and even then the webhook may land a
 * moment later.
 */
export const topUpHostDeposit = async (amount: number): Promise<IHostDepositTopUp> => {
  const response = await apiService<IHostDepositTopUp>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_HOST_DEPOSIT_TOP_UP,
    method: HTTP_METHODS.POST,
    body: { amount },
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to start the top-up');
};

/** Gives the deposit back and closes the account, minus what it cost to collect. Refused by the server while the host still has live bookings. */
export const closeHostDeposit = async (): Promise<IHostDeposit> => {
  const response = await apiService<IHostDeposit>({
    url: API_ENDPOINTS.HEAVY_DUTY_MACHINERY_HOST_DEPOSIT_CLOSE,
    method: HTTP_METHODS.POST,
    baseUrl: heavyDutyMachineryBaseUrl,
  });
  if (response.success) return response.data;
  throw new Error(response.error || 'Failed to close the deposit');
};
